import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Table
} from "reactstrap";
import moment from "moment";

const accessLevelLabels = {
  1: "Administrador",
  2: "Conteudista",
  3: "Professor ",
  4: "Aluno ",
  5: "Diretor ",
  6: "Administrador ",
  7: "Tutor ",
  8: "Assinante "
};

const LogDetails = ({ isOpen, toggle, log, getActionDescription, getActionCategory, getActionIcon }) => {
  const renderChanges = (data) => {
    if (!data || Object.keys(data).length === 0) {
      return (
        <div className="text-center text-muted">
          <p>Não há detalhes disponíveis sobre as mudanças realizadas.</p>
        </div>
      );
    }

    try {
      let changes = {};
      
      // Verifica o antes e depois
      if (data.before && data.after) {
        const before = data.before || {};
        const after = data.after || {};
        
        // Converter para o formato {field: {from: X, to: Y}}
        const allKeys = [...new Set([...Object.keys(before), ...Object.keys(after)])];
        
        allKeys.forEach(field => {
          if (JSON.stringify(before[field]) !== JSON.stringify(after[field])) {
            changes[field] = {
              from: before[field],
              to: after[field]
            };
          }
        });
      } else if (typeof data === 'object') {
        // Se já está com o formato {field: {from: X, to: Y}}
        changes = data;
      }

      // Filtrar campos indesejados
      const excludeFields = ['preference', 'updateDate', 'photo', 'blockedReason', 'createDate'];
      excludeFields.forEach(f => delete changes[f]);
      
      const significantChanges = {};
      Object.keys(changes).forEach(field => {
        const from = changes[field].from;
        const to = changes[field].to;
        
        const fromStr = from !== undefined ? String(from) : "";
        const toStr = to !== undefined ? String(to) : "";
        
        if (fromStr !== toStr) {
          significantChanges[field] = changes[field];
        }
      });
      
      if (Object.keys(significantChanges).length === 0) {
        return (
          <div className="text-center text-muted">
            <p>Não foram detectadas alterações significativas nos campos.</p>
          </div>
        );
      }
      
      const fieldLabels = {
        name: "Nome",
        lastName: "Sobrenome",
        email: "Email",
        username: "Nome de usuário",
        blocked: "Bloqueado",
        blockedQRcode: "QR Code bloqueado",
        blockedReason: "Motivo do bloqueio",
        accessLevel: "Nível de acesso",
        birthDate: "Data de nascimento",
        city: "Cidade",
        state: "Estado",
        tel: "Telefone",
        genre: "Gênero",
        company: "Unidade",
        verify: "Conta verificada",
        preference: "Preferências",
        password: "Senha",
        updateDate: "Data de atualização",
        lastAcess: "Último acesso"
      };
      
      const formatValue = (field, value) => {
        if (value === null || value === undefined) return "(vazio)";
        switch (field) {
          case 'blocked':
          case 'blockedQRcode':
          case 'verify':
            return value === '0' || value === 0 || value === false ? "Não" : "Sim";
          case 'birthDate':
            try {
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                return moment(date).format('DD/MM/YYYY');
              }
            } catch (e) {}
            return value;
          case 'genre':
            return value === '1' || value === 1 ? "Feminino" : "Masculino";
          case 'accessLevel':
            return accessLevelLabels[value] || value;
          case 'password':
            return "[Senha alterada]";
          default:
            return String(value);
        }
      };
      
      return (
        <div className="table-responsive">
          <Table className="align-items-center" bordered>
            <thead className="thead-light">
              <tr>
                <th style={{width: "30%"}}>Campo</th>
                <th style={{width: "70%"}}>Alteração</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(significantChanges).map(field => (
                <tr key={field}>
                  <td>
                    {fieldLabels[field] || field}
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <span className="text-danger">{formatValue(field, significantChanges[field].from)}</span>
                      <span className="px-2">
                        <i className="fas fa-long-arrow-alt-right text-primary"></i>
                      </span>
                      <span className="text-success">{formatValue(field, significantChanges[field].to)}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      );
    } catch (e) {
      console.error("Erro ao processar detalhes de alteração:", e);
      return (
        <div className="alert alert-warning">
          <p>Erro ao processar detalhes da alteração. Visualizando dados brutos:</p>
          <pre className="bg-light p-3 rounded small">{JSON.stringify(data, null, 2)}</pre>
        </div>
      );
    }
  };

  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Detalhes da {getActionCategory()}
      </ModalHeader>
      <ModalBody>
        <Card className="shadow-none">
          <CardBody>
            <Row className="mb-4">
              <Col md="4">
                <h5>Data e Hora:</h5>
                <p>{moment(log.createDate).format('DD/MM/YYYY HH:mm:ss')}</p>
              </Col>
              <Col md="4">
                <h5>Editor:</h5>
                <p>{log.userName} (ID: {log.user})</p>
              </Col>
              <Col md="4">
                <h5>Ação:</h5>
                <div>
                  <Badge color={
                      log.action === 'create' ? 'success' :
                      log.action === 'update' ? 'warning' : 'danger'
                    } className="mr-2">
                    <i className={`${getActionIcon()} mr-1`}></i>
                    {getActionCategory()}
                  </Badge>
                  <br/>
                  <span>{getActionDescription()}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <h5>Campos Alterados:</h5>
                {renderChanges(log.data)}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default LogDetails;